import { atas_finais } from "./atas-finais/routes";
import { encerrar_ano_letivo_lanca_historico } from "./encerrar-ano-letivo-lanca-historico/routes";
const encerramento_do_ano_letivo = [
  ...atas_finais,
  ...encerrar_ano_letivo_lanca_historico,
];

export { encerramento_do_ano_letivo };
